import React, { useState } from "react";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";

interface RFMSearchProps {
  onSearch: (filters: {
    startDate: Date;
    endDate: Date;
    recency: number | null;
    frequency: number | null;
    monetary: number | null;
    recencyScore: number | null;
    frequencyScore: number | null;
    monetaryScore: number | null;
    rfmTotal: number | null;
    customerSegment: string | null;
  }) => void;
  onReset: () => void;
}

const segmentOptions = [
  { label: "Champions", value: "Champions" },
  { label: "Loyal Customers", value: "Loyal Customers" },
  { label: "New Customers", value: "New Customers" },
  { label: "At Risk - High Value", value: "At Risk - High Value" },
  { label: "At Risk - Low Value", value: "At Risk - Low Value" },
  { label: "Big Spenders (Infrequent)", value: "Big Spenders (Infrequent)" },
  { label: "Lost Customers", value: "Lost Customers" },
  { label: "Need Attention", value: "Need Attention" },
];

const scoreOptions = [1, 2, 3, 4, 5].map((n) => ({ label: `${n}`, value: n }));
const rfmTotalOptions = Array.from({ length: 13 }, (_, i) => ({ label: `${i + 3}`, value: i + 3 }));

const RFMSearch: React.FC<RFMSearchProps> = ({ onSearch, onReset }) => {
  const today = new Date();
  const defaultStart = new Date();
  defaultStart.setFullYear(defaultStart.getFullYear() - 1);

  const [startDate, setStartDate] = useState<Date>(defaultStart);
  const [endDate, setEndDate] = useState<Date>(today);
  const [customerSegment, setCustomerSegment] = useState<string | null>(null);
  const [recencyScore, setRecencyScore] = useState<number | null>(null);
  const [frequencyScore, setFrequencyScore] = useState<number | null>(null);
  const [monetaryScore, setMonetaryScore] = useState<number | null>(null);
  const [rfmTotal, setRfmTotal] = useState<number | null>(null);
  const [recency, setRecency] = useState<number | null>(null);
  const [frequency, setFrequency] = useState<number | null>(null);
  const [monetary, setMonetary] = useState<number | null>(null);

  const handleSearch = () => {
    onSearch({
      startDate,
      endDate,
      recency,
      frequency,
      monetary,
      recencyScore,
      frequencyScore,
      monetaryScore,
      rfmTotal,
      customerSegment,
    });
  };

  const handleReset = () => {
    const newStart = new Date();
    newStart.setFullYear(newStart.getFullYear() - 1);
    setStartDate(newStart);
    setEndDate(new Date());
    setCustomerSegment(null);
    setRecencyScore(null);
    setFrequencyScore(null);
    setMonetaryScore(null);
    setRfmTotal(null);
    setRecency(null);
    setFrequency(null);
    setMonetary(null);
    onReset();
  };

  return (
    <div className="col-12">
      <div className="card border-noround p-3">
        <div className="grid">
          <div className="col-12 sm:col-6 lg:col-3">
            <label className="block text-sm font-medium mb-1">Start Date</label>
            <Calendar
              value={startDate}
              onChange={(e) => setStartDate(e.value as Date)}
              dateFormat="dd/mm/yy"
              showIcon
              className="w-full"
            />
          </div>
          <div className="col-12 sm:col-6 lg:col-3">
            <label className="block text-sm font-medium mb-1">End Date</label>
            <Calendar
              value={endDate}
              onChange={(e) => setEndDate(e.value as Date)}
              dateFormat="dd/mm/yy"
              showIcon
              className="w-full"
            />
          </div>
          <div className="col-12 sm:col-6 lg:col-3">
            <label className="block text-sm font-medium mb-1">Segment</label>
            <Dropdown
              value={customerSegment}
              options={segmentOptions}
              onChange={(e) => setCustomerSegment(e.value)}
              placeholder="All Segments"
              showClear
              className="w-full"
            />
          </div>
          <div className="col-12 sm:col-6 lg:col-3">
            <label className="block text-sm font-medium mb-1">RFM Total</label>
            <Dropdown
              value={rfmTotal}
              options={rfmTotalOptions}
              onChange={(e) => setRfmTotal(e.value)}
              placeholder="Any"
              showClear
              className="w-full"
            />
          </div>
          <div className="col-12 sm:col-6 lg:col-3">
            <label className="block text-sm font-medium mb-1">Recency Score</label>
            <Dropdown
              value={recencyScore}
              options={scoreOptions}
              onChange={(e) => setRecencyScore(e.value)}
              placeholder="Any"
              showClear
              className="w-full"
            />
          </div>
          <div className="col-12 sm:col-6 lg:col-3">
            <label className="block text-sm font-medium mb-1">Frequency Score</label>
            <Dropdown
              value={frequencyScore}
              options={scoreOptions}
              onChange={(e) => setFrequencyScore(e.value)}
              placeholder="Any"
              showClear
              className="w-full"
            />
          </div>
          <div className="col-12 sm:col-6 lg:col-3">
            <label className="block text-sm font-medium mb-1">Monetary Score</label>
            <Dropdown
              value={monetaryScore}
              options={scoreOptions}
              onChange={(e) => setMonetaryScore(e.value)}
              placeholder="Any"
              showClear
              className="w-full"
            />
          </div>
          <div className="col-12 sm:col-6 lg:col-3 flex align-items-end justify-content-end gap-2">
            <Button
              label="Reset"
              icon="pi pi-refresh"
              className="p-button-outlined p-button-secondary"
              onClick={handleReset}
            />
            <Button
              label="Filter"
              icon="pi pi-filter"
              onClick={handleSearch}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RFMSearch;
